import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  max-width: 800px;
  margin: 20px auto;
  background-color: #fff;
  padding: 20px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
`;

const TamilHeader = styled.h1`
  color: #0056b3;
  text-align: center;
  border-bottom: 2px solid #0056b3;
  padding-bottom: 10px;
  margin-bottom: 20px;
`;

const UniversityInfo = styled.div`
  text-align: center;
  font-size: 1.1em;
  margin-bottom: 20px;
`;

const CourseSection = styled.div`
  margin: 20px 0;
`;

const CourseTitle = styled.h2`
  color: #0056b3;
  margin-top: 25px;
`;

const CourseTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  
  th, td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: left;
  }
  
  th {
    background-color: #f2f2f2;
  }
`;

const Highlights = styled.div`
  background-color: #e6f7ff;
  padding: 10px;
  margin-top: 20px;
  border-left: 4px solid #0056b3;
`;

const ContactInfo = styled.div`
  text-align: center;
  margin-top: 30px;
  font-size: 1.1em;
`;

const CourseDetail = () => {
  return (
    <Container>
      <TamilHeader>ஜோதிஷ் யோக சாஸ்த்ரா பல்கலைக்கழகம்</TamilHeader>
      
      <UniversityInfo>
        தரமான கல்வி! நியாயமான கட்டணம்! அனுபவம் மிக்க ஆசிரியர்கள்!<br />
        <b>JYOTISH YOGA SASTRA UNIVERSITY, FLORIDA-USA</b><br />
        In Collaboration with<br />
        <b>VETRI FOUNDATION - MADURAI</b><br />
        90257 90247<br />
        இணையம்/பகுதி நேர படிப்புகள்
      </UniversityInfo>

      <CourseSection>
        <CourseTitle>Ph.D. வேதாங்க ஜோதிஷம்</CourseTitle>
        <p>
          <b>கால அளவு:</b> 02 வருடங்கள்<br />
          <b>சேர்க்கை தகுதி:</b> ஜோதிடவியலில் முதுகலை பட்டம் பெற்றிருக்க வேண்டும்
        </p>
      </CourseSection>

      <Highlights>
        <h3>ஜோதிடவியல் படிப்புகளின் சிறப்பம்சங்கள்:</h3>
        <ol>
          <li>அனைத்து பாடப்புத்தகங்களும் உடனடியாக அனுப்பி வைக்கப்படும்</li>
          <li>பதிவு செய்யப்பட்ட வீடியோக்கள் உடனடியாக Activation செய்யப்படும்</li>
          <li>மாதந்தோறும் Google Meet வாயிலாக பாடங்களுக்கு விளக்கமும் சந்தேகங்கள் நிவர்த்தியும் செய்யப்படும்</li>
          <li>எப்பொழுது வேண்டுமானாலும் எளிதில் தொடர்பு கொள்ளலாம்</li>
          <li>வாட்ஸ் அப் மற்றும் டெலிகிராம் வாயிலாக பல விதமான ஜோதிட தகவல்கள் வழங்கப்படும்.</li>
          <li>பொதுவான ஜோதிட விஷயங்களுக்கு astrology sastra Youtube மூலமாக விளக்கங்கள் தரப்படும்</li>
        </ol>
      </Highlights>

      <ContactInfo>
        தொடர்புக்கு: 90257 90247
      </ContactInfo>
    </Container>
  );
};

export default CourseDetail;